import React, { FC } from 'react';
import { Route, Redirect } from 'react-router-dom';
import { isMobile, isDesktop } from 'react-device-detect';
import { logOutAction, clearLoginAction } from '../redux/actions/login';
import { connect } from 'react-redux';
import DashboardNotAvailable from '../screens/Products/Plural/DashboardNotAvailable';
import PrivateLayout from '../layouts/PrivateLayout';
import { UiRoutes } from '../lib/constants';
import RedirectToLogin from './RedirectToLogin';

const EdgePrivateRoutes: FC<{
  component: FC;
  path: string;
  exact?: boolean;
  loginState;
  isAdmin: boolean;
  logOutAction: CallableFunction;
  clearLoginAction: CallableFunction;
  isPartnerMerchant?: boolean;
}> = (props) => {
  const { path, exact } = props;
  const Component = props.component;

  const { isUserAuthenticated, isWaitingForAPIResponse } = props.loginState;

  return !isWaitingForAPIResponse ? (
    isUserAuthenticated ? (
      isDesktop && !isMobile ? (
        props.isAdmin && !props.loginState.MerchantId ? (
          <Redirect to={UiRoutes.UNIFIED_MERCHANT_LISTING} />
        ) :
        (props.loginState.isPartnerMerchant && props.loginState.MerchantId === props?.loginState?.partnerId) ? 
        <Redirect to={UiRoutes.PARTNER_ALL_MERCHANTS} />
        :
        (
          <PrivateLayout>
            <Route
              path={path}
              exact={exact}
              render={(renderProps) => <Component {...renderProps} />}
            />
          </PrivateLayout>
        )
      ) : (
        <DashboardNotAvailable
          isAdmin={props.isAdmin}
          onClickHandler={
            props.loginState.showOtpScreen
              ? props.clearLoginAction
              : props.logOutAction
          }
        />
      )
    ) : (
      <RedirectToLogin />
    )
  ) : (
    <React.Fragment></React.Fragment>
  );
};

const mapStateToProps = ({ loginReducer }) => ({
  loginState: loginReducer.loginState,
  isAdmin: loginReducer.loginState.isAdmin,
});

export default connect(mapStateToProps, { logOutAction, clearLoginAction })(
  EdgePrivateRoutes
);
